import { createContext } from 'react';
import type { ColorMode } from './index';
import type { PresetGroup } from './registry';

export type ColorModePreference = ColorMode | 'system';

export interface ColorModeContextValue {
  mode: ColorMode;
  preference: ColorModePreference;
  setPreference: (preference: ColorModePreference) => void;
  toggle: () => void;
  /** The active theme preset id (see `theme/presets.ts`). */
  presetId: string;
  setPresetId: (presetId: string) => void;
  /** Every preset, grouped by category, for pickers. */
  presets: PresetGroup[];
}

export const ColorModeContext = createContext<ColorModeContextValue | undefined>(undefined);
